import { render, staticRenderFns } from "./scientific-free-response.vue?vue&type=template&id=5bb70b24&scoped=true"
import script from "./scientific-free-response.ts?vue&type=script&lang=ts&external"
export * from "./scientific-free-response.ts?vue&type=script&lang=ts&external"
import style0 from "./scientific-free-response.scss?vue&type=style&index=0&id=5bb70b24&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb70b24",
  null
  
)

export default component.exports